    <div>
        <div class="row" id="sticky-nav">
            <ng-container *ngIf="(brands && brands.Brands) && (categories && categories.Categories)">
                <app-nav-menu [brands]="brands.Brands" [categories]="categories.Categories" [decorations]="decorations"
                    (menuOption)="filterProducts($event)" [searchParam]="search"> </app-nav-menu>
            </ng-container>
        </div>
        <router-outlet></router-outlet>
    </div>
    <cs-footer></cs-footer>


